import React, { type FC } from 'react';
import { SectionHelper, TextButton, Text, Box } from '@wix/design-system';
import { StatusWarning } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';

const LEARN_MORE_BLOCKS_TEMPLATE =
  'https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-blocks/about-wix-harmony-and-blocks';

export const BlocksHarmonyNotification: FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <SectionHelper
      dataHook="blocks-notification"
      appearance="warning"
      fullWidth
      showPrefixIcon
      prefixIcon={<StatusWarning />}
      title={t('app.grid.blocks.notification.title')}
    >
      <Box direction="vertical" gap="6px">
        <Text size="small">
          {t('app.grid.blocks.notification.description')} {' '}
          <TextButton
            size="small"
            as="a"
            href={LEARN_MORE_BLOCKS_TEMPLATE}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('app.grid.blocks.notification.learn-more')}
          </TextButton>
        </Text>
      </Box>
    </SectionHelper>
  );
};
